import { AccountingEntriesFieldsConfiguration, DescriptionOption } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { clientThirdPartTemplatingNameFieldOption, clientThirdPartyTemplatingOptions, defaultEntryDescriptionEmptyFieldOption, defaultEntryLineDescriptionStandardFieldOption, defaultGroupingDescriptionEmptyFieldOption, getPaymentEntryDescriptionFieldOptions, getPaymentEntryLineDescriptionFieldOptions, getPaymentGroupingDescriptionFieldOptions, getSellInvoiceEntryDescriptionFieldOptions, getSellInvoiceEntryLineDescriptionFieldOptions, getSellInvoiceGroupingDescriptionFieldOptions, supplierThirdPartTemplatingNameFieldOption, supplierThirdPartyTemplatingOptions } from './default-transformation-fields';
import { JournalOptionEnum } from '~modules/connectors/constants/journal.options';
import { ReverseChargeAggregateOptionEnum } from '~modules/connectors/constants/reverse-charge-aggregate.options';
import { InvoiceGenerationOptionEnum } from '~modules/connectors/constants/Invoice-generation.option';
import { InvoiceAmountDifferenceOptionEnum } from '~modules/connectors/constants/invoice-amount-difference.option';
import { DocumentRefOptionEnum, getDocumentRefOptions } from '~modules/connectors/constants/document-ref.option';


const zenotiPaymentGroupingDescriptionOptions: DescriptionOption[] = getPaymentGroupingDescriptionFieldOptions();

const zenotiPaymentEntryDescriptionOptions: DescriptionOption[] = getPaymentEntryDescriptionFieldOptions({
    withThirdPart: true
});

const zenotiPaymentEntryLineDescriptionOptions: DescriptionOption[] = getPaymentEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

const zenotiSellInvoiceGroupingDescriptionOptions: DescriptionOption[] = getSellInvoiceGroupingDescriptionFieldOptions();

const zenotiSellInvoiceEntryDescriptionOptions: DescriptionOption[] = getSellInvoiceEntryDescriptionFieldOptions({
    withThirdPart: true
});

const zenotiSellInvoiceEntryLineDescriptionOptions: DescriptionOption[] = getSellInvoiceEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

export const zenotiTransformationFieldsConfiguration: AccountingEntriesFieldsConfiguration = {
    toolLabel: 'Zenoti',

    paymentProcessorConfiguration: {
            journalOption: {
                defaultValue: JournalOptionEnum.BY_PAYMENT_METHOD,
            },
            uniqueJournal: {
                code: {
                    defaultValue: 'PND'
                },
                label: {
                    defaultValue: 'Paiement Non Défini'
                }
            },
            client: {
                useSuggestedAccounts: {
                    visible: false,
                    defaultValue: false
                },
                account: {
                    defaultValue: '411'
                },
                label: {
                    defaultValue: 'Clients'
                },
                isDynamic: {
                    defaultValue: false
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryDynamic: {
                    options: clientThirdPartyTemplatingOptions,
                    defaultOption: clientThirdPartTemplatingNameFieldOption
                }
            },
            supplier: {
                visible: false,
                useSuggestedAccounts: {
                    defaultValue: false
                },
                account: {
                    defaultValue: '401'
                },
                label: {
                    defaultValue: 'Fournisseurs'
                },
                isDynamic: {
                    visible: false,
                    defaultValue: false
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryDynamic: {
                    options: supplierThirdPartyTemplatingOptions,
                    defaultOption: supplierThirdPartTemplatingNameFieldOption
                }
            },
            useSuggestedProviderAccounts: {
                visible: false,
                defaultValue: false
            },
            methods: {
                unique: false,
                paymentMethodOptions: [
                    'Espèces',
                    'Carte',
                    'Chèque'
                ],
                defaultMethod: {
                    name: null,
                    export: true,
                    journalCode: 'PND',
                    provider: {
                        account: '5899',
                        label: 'Non défini'
                    }
                }
            },
            providerFee: {
                visible: false,
                account: {
                    defaultValue: '62781'
                },
                label: {
                    defaultValue: 'Autres frais et commissions sur prestations de services'
                }
            },
            deductibleVat20: {
                visible: false,
                account: {
                    defaultValue: '44566'
                },
                label: {
                    defaultValue: 'TVA sur autres biens et services'
                }
            },
            reverseCharge: {
                visible: false,
                has: {
                    defaultValue: false
                },
                aggregateOption: {
                    defaultValue: ReverseChargeAggregateOptionEnum.EACH
                },
                collectedIntracomVat: {
                    account: {
                        defaultValue: '4452'
                    },
                    label: {
                        defaultValue: 'TVA due intracommunautaire'
                    }
                },
                deductibleIntracomVat: {
                    account: {
                        defaultValue: '445662'
                    },
                    label: {
                        defaultValue: 'TVA intracommunautaire sur autres biens et services'
                    }
                },
                vatRate: {
                    defaultValue: 20.00
                }
            },
            useSuggestedCounterpartAccounts: {
                visible: false,
                defaultValue: false
            },
            undefinedCredit: {
                visible: false,
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            undefinedDebit: {
                visible: false,
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            groupingDescription: {
                visible: false,
                options: zenotiPaymentGroupingDescriptionOptions,
                defaultOption: defaultGroupingDescriptionEmptyFieldOption
            },
            entryDescription: {
                options: zenotiPaymentEntryDescriptionOptions,
                defaultOption: defaultEntryDescriptionEmptyFieldOption,
            },
            entryLineDescription: {
                options: zenotiPaymentEntryLineDescriptionOptions,
                defaultOption: defaultEntryLineDescriptionStandardFieldOption,
            }
        },
        
        sellInvoiceProcessorConfiguration: {
            journal: {
                code: {
                    defaultValue: 'VT'
                },
                label: {
                    defaultValue: 'Ventes'
                }
            },
            thirdPartyAccount: {
                useSuggestedAccounts: {
                    visible: false,
                    defaultValue: false
                },
                account: {
                    defaultValue: '411'
                },
                label: {
                    defaultValue: 'Clients'
                },
                isDynamic: {
                    defaultValue: false
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'ZENOTI'
                },
                auxiliaryDynamic: {
                    options: clientThirdPartyTemplatingOptions,
                    defaultOption: clientThirdPartTemplatingNameFieldOption
                }
            },
            generation: {
                useSuggestedProductsAccounts: {
                    visible: false,
                    defaultValue: false
                },
                option: {
                    defaultWithSuggestedAccountValue: null,
                    defaultWithoutSuggestedAccountValue: InvoiceGenerationOptionEnum.ONE_LINE_PER_VAT_RATE
                },
                oneLinePerVatRate: {
                    productVats: {
                        columns: {
                            countryCode: {
                                visible: false,
                                canEdit: false
                            },
                            regime: {
                                visible: false,
                                canEdit: false
                            }
                        },
                        defaultAccount: {
                            countryCode: null,
                            regime: null,
                            rate: null,
                            account: '701099',
                            accountLabel: 'Produits à reclasser'
                        },
                        accounts: [
                            {
                                countryCode: null,
                                regime: null,
                                rate: 20,
                                account: '701020',
                                accountLabel: 'Ventes TVA 20%'
                            }
                        ]
                    }
                },
                oneGlobalLine: {
                    product: {
                        account: {
                            defaultValue: '701000'
                        },
                        label: {
                            defaultValue: 'Produit'
                        }
                    }
                }
            },
            useSuggestedVatsAccounts: {
                visible: false,
                defaultValue: false
            },
            collectedVats: {
                columns: {
                    countryCode: {
                        visible: false,
                        canEdit: false
                    },
                    regime: {
                        visible: false,
                        canEdit: false
                    }
                },
                defaultAccount: {
                    countryCode: null,
                    regime: null,
                    rate: null,
                    account: '44571099',
                    accountLabel: 'TVA à reclasser'
                },
                accounts: [
                    {
                        countryCode: 'FR',
                        regime: null,
                        rate: 20,
                        account: '44571020',
                        accountLabel: 'TVA collectée 20%'
                    }
                ]
            },
            amountDifferenceOption: {
                visible: false,
                defaultValue: InvoiceAmountDifferenceOptionEnum.ADJUST_HT
            },
            debitAdjustment: {
                visible: false,
                account: {
                    defaultValue: "658"
                },
                label: {
                    defaultValue: "Charges diverses de gestion courante"
                }
            },
            creditAdjustment: {
                visible: false,
                account: {
                    defaultValue: "758"
                },
                label: {
                    defaultValue: "Produits divers de gestion courante"
                }
            },
            documentRef: {
                visible: false,
                options: getDocumentRefOptions(),
                defaultValue: DocumentRefOptionEnum.INVOICE_FUNCTIONAL_ID
            },
            groupingDescription: {
                visible: false,
                options: zenotiSellInvoiceGroupingDescriptionOptions,
                defaultOption: defaultGroupingDescriptionEmptyFieldOption
            },
            entryDescription: {
                options: zenotiSellInvoiceEntryDescriptionOptions,
                defaultOption: defaultEntryDescriptionEmptyFieldOption,
            },
            entryLineDescription: {
                options: zenotiSellInvoiceEntryLineDescriptionOptions,
                defaultOption: defaultEntryLineDescriptionStandardFieldOption,
            }
        },

    analyticProcessorConfiguration: {
        isEnabled: {
            defaultValue: false
        },
        accountRules: {}
    }
}